import SiteWrapper from "../../SiteWrapper.react";
import React from "react";
import '../../css/ProjectDetail.css';
import {useFormik} from "formik";
import {Container, Card, Box, TextField, FormControl, InputLabel, Button, Stack, Select, MenuItem, Grid} from "@mui/material";
import {TrueffortButton, TrueffortSelect, TrueffortTextField} from "../../MUIstyle/MUICustom";
import {Save as SaveIcon, Cancel as CancelIcon} from '@mui/icons-material';
import ProjectElementService from "../../services/projectElement.service";
import {toast} from "react-toastify";
import { useState } from "react";
import SelectMulti from 'react-select';
import { useMemo } from "react";
import ProjectTaskService from "../../services/projectTask.service";


// @ts-ignore
function AssignUsersToTask({users, t, formState, setFormState, project, _fillProjectInfo}) {
  //console.log(project);
  //console.log(users);
  const types = [{id:0, name: "Proyecto"}, {id:1, name: "Elemento"}, {id:2, name: "Fase"}, {id:3, name: "Tarea"}];
  const [items, setItems]:any = useState([{id: project.id, name: project.name}]);

    const projectElementService = React.useMemo(() => new ProjectElementService(), []);
    const projectTaskService = useMemo(() => new ProjectTaskService(), []);

    const validate = (values: any) => {
        let errors: any = {};
        if (!values.idUser) {
            errors.idUser = "Required";
        }
        if (!values.idType) {
            errors.idType = "Required";
        }
        if (values.idItems.length == 0) {
          errors.idItems = "Required";
        }
        return errors;
    }

    const formik = useFormik({
        initialValues: {
            idType: '',
            idUser: '',
            idItems: []
        },
        validate: validate,
        onSubmit: (values) => {
            handleSubmit(values);
        }
    });

    const handleSubmit = (values: any) => {
        // @ts-ignore
        projectTaskService.assignUsersToTaskMassiva(values.idUser?.value, values.idType?.value, values.idItems.map((it:any) => it.value))
          .then(({data: response}:any) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                toast.error(response.message);
            } else {
                setFormState({...formState, showFormAssign: false, isCreating: false});
                toast.success(t("project_page.msg_success_pe_add"));
            }
            _fillProjectInfo();
        });
    }

    const handleCancel = () => {
        formik.resetForm();
        setFormState({...formState, isCreating: false, isEditing: false, showFormAssign: false})
    }


    return (
        <Card sx={{padding: "12px", marginTop: "1rem", overflow: "unset", marginBottom: "1rem"}} className="background-gray">
            <h6>{"Asignar a usuario"}</h6>
            
            <Grid container spacing={2}>
            <Grid item xs={4}>
            <InputLabel
                  required={true}
                  sx={{
                      fontWeight: 700,
                      color: '#4A4A4A',
                      '& .MuiInputLabel-asterisk': {
                          color: "#E4555A"
                      },
                      fontSize: '0.75rem'
                  }}
              >
                  {"Seleccione el tipo de item"}
              </InputLabel>
              <SelectMulti
                id="idNewType"
                sx={{ background: "white" }}
                size="small"
                label={"Seleccione el tipo de item"}
                name="idType"
                value={formik.values.idType}
                onChange={(option: any) => {
                  formik.setFieldValue('idType', option);
                  let its:any = [];
                  switch(option.value) {
                    case 0:
                      its = [{id: project.id, name: project.name}];
                      break;
                    case 1:
                      its = project.elements.map((ele:any) => ({id: ele.id, name: ele.name}));
                      break;
                    case 2:
                      for (let i = 0; i < project.elements.length; i++) {
                        project.elements[i].phases.forEach((ph:any) => its.push({id: ph.id, name: project.elements[i].name + " - " +ph.type_name}));
                      }
                      break;
                    case 3:
                      for (let i = 0; i < project.elements.length; i++) {
                        for (let j = 0; j < project.elements[i].phases.length; j++) {
                          project.elements[i].phases[j].tasks.forEach((pt:any) => its.push({id: pt.id, name: project.elements[i].name + " - " +
                          project.elements[i].phases[j].type_name + " - " + pt.type_name}));
                        }
                      }
                      break;
                  }
                  setItems(its);
                  formik.setFieldValue('idItems', [])
                }}
                options={
                  types.map((ite: any) => {
                    return { value: ite.id, label: ite.name };
                  })
                }
              />
              {formik.touched.idType && formik.errors.idType && <span style={{color:'crimson', fontSize: '12px'}}>{t(formik.errors.idType)}</span>}
            </Grid>
            <Grid item xs={4}>
              <InputLabel
                  required={true}
                  sx={{
                      fontWeight: 700,
                      color: '#4A4A4A',
                      '& .MuiInputLabel-asterisk': {
                          color: "#E4555A"
                      },
                      fontSize: '0.75rem'
                  }}
              >
                  {"Seleccione el usuario"}
              </InputLabel>
              <SelectMulti
                id="idNewUser"
                sx={{ background: "white" }}
                size="small"
                label={"Seleccione el usuario"}
                name="idUser"
                value={formik.values.idUser}
                onChange={(option: any) => formik.setFieldValue('idUser', option)}
                options={
                  users.map((ite: any) => {
                    return { value: ite.idUser, label: ite.fullNameEmail };
                  })
                }
              />
              {formik.touched.idUser && formik.errors.idUser && <span style={{color:'crimson', fontSize: '12px'}}>{t(formik.errors.idUser)}</span>}
            </Grid>
            <Grid item sm={10}>
              <InputLabel
                  required={true}
                  sx={{
                      fontWeight: 700,
                      color: '#4A4A4A',
                      '& .MuiInputLabel-asterisk': {
                          color: "#E4555A"
                      },
                      fontSize: '0.75rem'
                  }}
              >
                  {"Asignar items"}
              </InputLabel>
              <SelectMulti
                id="idSlNewLeader"
                sx={{ background: "white" }}
                size="small"
                isMulti
                label={t("leader.assign")}
                name="idLeader"
                value={formik.values.idItems}
                onChange={(option: any) => formik.setFieldValue('idItems', option)}
                options={
                  items.map((ite: any) => {
                    return { value: ite.id, label: ite.name };
                  })
                }
              />
              {formik.touched.idItems && formik.errors.idItems && <span style={{color:'crimson', fontSize: '12px'}}>{t(formik.errors.idItems)}</span>}
            </Grid>
              <Grid item sm={2} style={{display:'flex', alignItems: 'end', justifyContent:'end'}}>
              <TrueffortButton id="idBtnSaveElement" color="primary" variant="outlined" size="small" onClick={() => formik.handleSubmit()}>
                    <SaveIcon />
                </TrueffortButton>
                <div style={{paddingRight:'0.2em'}}></div>
                <TrueffortButton id="idBtnSaveElement" color="secondary" variant="outlined" size="small" onClick={handleCancel}>
                    <CancelIcon />
                </TrueffortButton>
              </Grid>
            </Grid>
        </Card>
    );
}

export default AssignUsersToTask;